export const IMAGE_CDN_URL = 'https://d207ibygpg2z1x.cloudfront.net/image/upload';
